import React, { useState, useEffect, useRef } from 'react';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import { useSelector } from 'react-redux';
import methodModel from '../../methods/methods';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Layout from '../../components/global/layout';
import { Tooltip } from 'antd';
import 'react-quill/dist/quill.snow.css';
import { toast } from 'react-toastify';
import SelectDropdown from '../../components/common/SelectDropdown';

const AddEditPlan = () => {
  const [features, setFeatures] = useState([]);
  const [SelectedFeature, setSelectedFeatures] = useState([]);
  const [Roles, setRoles] = useState([]);
  const [role, setrole] = useState('coaches');

  const [OneMonth, setOneMonth] = useState({
    label: '1 Month',
    interval_count: 1,
    interval_time: 'month',
    unit_amount: '',

    is_most_popular: false,
  });
  const [ThreeMonth, setThreeMonth] = useState({
    label: '3 Months',
    interval_count: 3,
    interval_time: 'month',
    unit_amount: '',

    is_most_popular: false,
  });
  const [SixMonth, setSixMonth] = useState({
    label: '6 Months',
    interval_count: 6,
    interval_time: 'month',
    unit_amount: '',

    is_most_popular: false,
  });
  const [TwelveMonth, setTwelveMonth] = useState({
    label: '12 Months',
    interval_count: 12,
    interval_time: 'month',
    unit_amount: '',

    is_most_popular: false,
  });
  const { id } = useParams();
  const [form, setform] = useState({ pricing: [] });
  const [startIndex, setStartIndex] = useState(-1);
  const [enterIndex, setEnterIndex] = useState(-1);
  const [selectedItem, setSelectedItem] = useState('');
  const history = useNavigate();
  const [submitted, setSubmitted] = useState(false);
  const user = useSelector((state) => state.user);
  const dragItem = useRef();
  const dragItems = useRef();
  const dragOverItem = useRef();
  const formValidation = [{ key: 'name', required: true }];
  const [Checked1, setChecked1] = useState(false);
  const [Checked3, setChecked3] = useState(false);
  const [Checked6, setChecked6] = useState(false);
  const [Checked12, setChecked12] = useState(false);


  const [IntervalData, setIntervalData] = useState([
    {
      interval_time: '',
      interval_count: '',
      label: '',

      unit_amount: '',
    },
  ]);

  const HandleMostPopular = (setState) => {
    setOneMonth((prevState) => ({ ...prevState, is_most_popular: false }))
    setThreeMonth((prevState) => ({ ...prevState, is_most_popular: false }))
    setSixMonth((prevState) => ({ ...prevState, is_most_popular: false }))
    setTwelveMonth((prevState) => ({ ...prevState, is_most_popular: false }))
    setState((prevState) => ({ ...prevState, is_most_popular: true }))
  };


  const GetRole = () => {
    ApiClient.get('role/all').then((res) => {
      if (res.success) {
        const data = res.data;
        setRoles(data);
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (!id && role != "leagues") {
      if (!Checked1 || !Checked3 || !Checked6 || !Checked12) {
        return toast.error("Please select all intervals")
      }
    }
    let arr = [];

    if (role === "leagues") {
      arr.push(TwelveMonth)
    } else {
      if (Checked1) {
        arr.push(OneMonth);
      }
      if (Checked3) {
        arr.push(ThreeMonth);
      }
      if (Checked6) {
        arr.push(SixMonth);
      }
      if (Checked12) {
        arr.push(TwelveMonth);
      }
    }


    let invalid = methodModel.getFormError(formValidation, form);
    if (invalid) return;
    if (SelectedFeature?.length < 1) {
      return toast.error('Please select feature');
    }
    let method = 'post';
    let url = 'subscription-plan';
    let value = {
      ...form,
      features: SelectedFeature,
      pricing: arr,
      role: role,
      seats: form?.seats,
      unit_amount: form?.unit_amount,

    };

    if (id) {
      method = 'put';
      url = 'subscription-plan';
      value = {
        features: SelectedFeature,
        name: form?.name,
        seats: form?.seats,
        pricing: arr,
        role: role,

        unit_amount: form?.unit_amount,
        id: JSON.parse(id),

      };
      // delete value?.pricing;
    } else {
      // value.addedBy = user._id;

      delete value.id;
    }
    loader(true);
    ApiClient.allApi(url, value, method).then((res) => {
      if (res.success) {
        history('/plans');
      }
      loader(false);
    });
  };

  const getFeatures = (feature = {}) => {
    let f = feature;
    ApiClient.get('features', {
      page: 1,
      count: 100,
      status: 'active',
      isDeleted: false,
    }).then((res) => {
      if (res.success) {
        let data = res?.data;
        setFeatures(data);
      }
    });
  };

  useEffect(() => {

    GetRole();
    mostpopular();
  }, []);


  useEffect(() => {
    if (id) {
      loader(true);
      ApiClient.get('subscription-plan', { id }).then((res) => {
        if (res.success) {
          let value = res.data;
          setform(res?.data);
          setIntervalData(res?.data?.pricing);
          setrole(res?.data?.role || " ")
          setSelectedFeatures(res?.data?.features);
          setOneMonth(res?.data?.pricing[0]);
          setThreeMonth(res?.data?.pricing[1]);
          setSixMonth(res?.data?.pricing[2]);
          { res?.data?.role === "leagues" ? setTwelveMonth(res?.data?.pricing[0]) : setTwelveMonth(res?.data?.pricing[3]) }

          setChecked1(res?.data?.pricing?.[0]);


          setChecked3(res?.data?.pricing?.[1]);
          setChecked6(res?.data?.pricing?.[2]);
          // setChecked12(res?.data?.pricing?.[3])
          { res?.data?.role === "leagues" ? setChecked12(res?.data?.pricing[0]) : setChecked12(res?.data?.pricing[3]) }

        }
        loader(false);
      });
    }
    getFeatures();
  }, [id]);


  const mostpopular = () => {
    console.log("jjjj")
    ApiClient.get('popular-plan').then((res) => {
      console.log(res?.data, "jjjj")
    })
  }

  const dragStart = (e, position, key = '') => {
    dragItem.current = position;
    setStartIndex(position);
    setSelectedItem(key);
  };

  const dragEnter = (e, position, key = '') => {
    dragOverItem.current = position;
    setEnterIndex(position);
    const copyListItems = [...features[key]];
    const dragItemContent = copyListItems[dragItem.current];
    copyListItems.splice(dragItem.current, 1);
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);
    dragItems.current = { ...dragItems.current, [key]: copyListItems };
  };

  const drop = (e, key = '') => {
    setStartIndex(-1);
    setEnterIndex(-1);
    setSelectedItem('');
    const copyListItems = [...features[key]];
    const dragItemContent = copyListItems[dragItem.current];
    copyListItems.splice(dragItem.current, 1);
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    // dragItems.current={...dragItems.current,[key]:copyListItems}
    setFeatures({ ...features, [key]: copyListItems });
  };

  const isFeatureSelected = (featureName) => {
    return SelectedFeature.some((itm) => itm?.id == featureName);
  };

  const Role = [
    { id: 'coaches', name: 'Coaches' },
    { id: 'leagues', name: 'Leagues' },
  ];

  return (
    <>
      <Layout>
        {role == "coaches" ? <form onSubmit={handleSubmit}>
          <div className="pprofile1 shadow-lg">
            <div className="flex items-center mb-8">
              <Tooltip placement="top" title="Back">
                <Link
                  to="/plans"
                  className="!px-4  py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all   mr-3"
                >
                  <i className="fa fa-angle-left text-lg"></i>
                </Link>
              </Tooltip>
              <div>
                <h3 className="text-2xl font-semibold text-[#111827]">
                  {id ? 'Edit' : 'Add'} Plan
                </h3>
                <p class="text-sm font-normal text-[#525252]">
                  Here you can see all about your Planss
                </p>
              </div>
            </div>

            <div className="grid grid-cols-12 gap-5">
              <div className="col-span-6 md:col-span-6 mb-3">
                <label>
                  Select Roles<span className="star">*</span>
                </label>
                <div className="relative mb-6 mt-2">
                  <SelectDropdown
                    disabled={id}
                    id="statusDropdown"
                    displayValue="name"
                    placeholder="Select Role"
                    intialValue={role}
                    result={(e) => {
                      setrole(e.value);
                    }}
                    options={Role}
                  />

                </div>
              </div>
            </div>


            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-6 md:col-span-6 mb-3">
                <label>
                  Name<span className="star">*</span>
                </label>
                <input
                  type="text"
                  className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                  value={form.name}
                  onChange={(e) => setform({ ...form, name: e.target.value })}
                  required
                />
              </div>

            </div>
            <div className="grid grid-cols-12 gap-4">
              {/* {id ? null : ( */}
              <>
                <div className="col-span-12 md:col-span-6 mb-3">
                  <div className='flex items-center mb-1'>
                    <input
                      disabled={id}
                      checked={Checked1}
                      onChange={(e) => setChecked1(e.target.checked)}
                      type="checkbox" className='w-[15px] h-[15px]'
                    />
                    <input
                      type="text"
                      className="bg-white"
                      value={OneMonth?.label}
                      disabled
                      required={Checked1}
                    />
                    <input
                      onClick={() => HandleMostPopular(setOneMonth)}
                      type="checkbox" className='w-[15px] h-[15px]'
                      checked={OneMonth?.is_most_popular}
                    />
                    <p>Popular</p>
                  </div>
                  <input
                    type="number"
                    placeholder="Unit Amount"
                    className="relative shadow-box bg-white rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2 w-full"
                    value={OneMonth?.unit_amount}
                    disabled={!Checked1||id}
                    onChange={(e) => {
                      setOneMonth({
                        ...OneMonth,
                        unit_amount: e.target.value,
                      });
                    }}
                    onKeyPress={(e) => {
                      const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
                      if (!allowedKeys.includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    required={Checked1}
                  />
                </div>

                <div className="col-span-12 md:col-span-6 mb-3">
                  <div className='flex items-center mb-1'>
                    <input
                      disabled={id}
                      checked={Checked3}
                      onChange={(e) => setChecked3(e.target.checked)}
                      type="checkbox" className='w-[15px] h-[15px]'
                    />
                    <input
                      type="text"
                      className="bg-white"
                      value={ThreeMonth?.label}
                      disabled
                      required={Checked3}
                    />
                    <input
                      onClick={() => HandleMostPopular(setThreeMonth)}
                      type="checkbox" className='w-[15px] h-[15px]'
                      checked={ThreeMonth?.is_most_popular}
                    />
                    <p>Popular</p>
                  </div>
                  <input
                    type="number"
                    placeholder="Unit Amount"
                    className=" relative shadow-box bg-white rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2 w-full"
                    value={ThreeMonth?.unit_amount}
                    disabled={!Checked3||id}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      if (inputValue >= 0) {
                        setThreeMonth({
                          ...ThreeMonth,
                          unit_amount: inputValue,
                        });
                      }
                    }}
                    onKeyPress={(e) => {
                      const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
                      if (!allowedKeys.includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    required={Checked3}
                  />
                </div>
                <div className="col-span-12 md:col-span-6 mb-3">
                  <div className='flex items-center mb-1'>
                    <input
                      disabled={id}
                      checked={Checked6}
                      onChange={(e) => setChecked6(e.target.checked)}
                      type="checkbox" className='w-[15px] h-[15px]'
                    />
                    <input
                      type="text"
                      className="bg-white"
                      value={SixMonth?.label}
                      disabled
                      required={Checked6}
                    />
                    <input
                      onClick={() => HandleMostPopular(setSixMonth)}
                      type="checkbox" className='w-[15px] h-[15px]'
                      checked={SixMonth?.is_most_popular}
                    />
                    <p>Popular</p>
                  </div>
                  <input
                    type="number"
                    placeholder="Unit Amount"
                    className=" relative shadow-box bg-white rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2 w-full"
                    value={SixMonth?.unit_amount}
                    disabled={!Checked6 || id}
                    min={0}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      if (inputValue >= 0) {
                        setSixMonth({
                          ...SixMonth,
                          unit_amount: inputValue,
                        });
                      }
                    }}
                    onKeyPress={(e) => {
                      const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
                      if (!allowedKeys.includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    required={Checked6}
                  />
                </div>

                <div className="col-span-12 md:col-span-6 mb-3">
                  <div className='flex items-center mb-1'>
                    <input
                      disabled={id}
                      checked={Checked12}
                      onChange={(e) => setChecked12(e.target.checked)}
                      type="checkbox" className='w-[15px] h-[15px]'
                    />
                    <input
                      type="text"
                      className="bg-white"
                      value={TwelveMonth?.label}
                      // disabled
                      required={Checked12}
                    />
                    <input
                      onClick={() => HandleMostPopular(setTwelveMonth)}
                      type="checkbox" className='w-[15px] h-[15px]'
                      checked={TwelveMonth?.is_most_popular}
                    />
                    <p>Popular</p>
                  </div>
                  <input

                    type="number"
                    placeholder="Unit Amount"
                    className=" relative shadow-box bg-white rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2 w-full"
                    value={TwelveMonth?.unit_amount}
                    disabled={!Checked12||id}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      if (inputValue >= 0) {
                        setTwelveMonth({
                          ...TwelveMonth,
                          unit_amount: inputValue,
                        });
                      }
                    }}
                    onKeyPress={(e) => {
                      const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
                      if (!allowedKeys.includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    required={Checked12}
                  />
                </div>
              </>
              {/* )} */}
              <div className="col-span-12 md:col-span-12">
                <div className="">
                  <h5 className="text-[#A12238]">
                    <b> Features </b>
                  </h5>
                </div>
                <div className="grid grid-cols-12 gap-4">
                  {features &&
                    features?.map((item, index) => {
                      return (
                        <>
                          {/* <div className={`col-span-4`}> */}
                          <div
                            className={`${features?.length === 1 ? 'col-span-12' : 'col-span-6'
                              }`}>
                            <label class="form-check-label pointer">
                              <input
                                class="form-check-input w-[15px] h-[15px] relative top-[2px]" id="red-checkbox"
                                type="checkbox"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelectedFeatures([
                                      ...SelectedFeature,
                                      { id: `${item.id}` },
                                    ]);
                                  } else {
                                    setSelectedFeatures(
                                      SelectedFeature.filter(
                                        (feature) => feature?.id != item.id
                                      )
                                    );
                                  }
                                }}
                                checked={isFeatureSelected(item?.id)}
                              />
                              {item?.name}
                            </label>
                          </div>
                        </>
                      );
                    })}
                </div>
              </div>

            </div>
            <div className="flex justify-end">
              <button
                type="submit"
                className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:opacity-80 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
              >
                Save
              </button>
            </div>
          </div>
        </form>
          :
          <form onSubmit={handleSubmit}>
            <div className="pprofile1 shadow-lg">
              <div className="flex items-center mb-8">
                <Tooltip placement="top" title="Back">
                  <Link
                    to="/plans"
                    className="!px-4  py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all   mr-3"
                  >
                    <i className="fa fa-angle-left text-lg"></i>
                  </Link>
                </Tooltip>
                <div>
                  <h3 className="text-2xl font-semibold text-[#111827]">
                    {id ? 'Edit' : 'Add'} Plan
                  </h3>
                  <p class="text-sm font-normal text-[#525252]">
                    Here you can see all about your Plan
                  </p>
                </div>
              </div>


              <div className="grid grid-cols-12 gap-5">
                <div className="col-span-6 md:col-span-6 mb-3">
                  <label>
                    Select Roles<span className="star">*</span>
                  </label>
                  <div className="relative mb-6 mt-2">
                    <SelectDropdown
                      disabled={id}
                      id="statusDropdown"
                      displayValue="name"
                      placeholder="Select Role"
                      intialValue={role}
                      result={(e) => {
                        setrole(e.value);
                      }}
                      options={Role}

                    />

                  </div>
                </div>
              </div>


              <div className="grid grid-cols-12 gap-5">
                <div className="col-span-6 md:col-span-6 mb-3">
                  <label>
                    Name<span className="star">*</span>
                  </label>
                  <input
                    type="text"
                    className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2"
                    value={form.name}
                    onChange={(e) => setform({ ...form, name: e.target.value })}
                    required
                  />
                </div>


                <div className="grid grid-cols-12 gap-4">
                  <div className="col-span-6 md:col-span-6 mb-3">
                    <label>
                      Seats<span className="star">*</span>
                    </label>
                    <input
                      type="number"
                      min="1"
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2"
                      value={form.seats === 0 ? '' : form.seats}
                      onChange={(e) => {
                        const newValue = Number(e.target.value);
                        if (newValue < 1) {
                          setform({ ...form, seats: '' });
                        } else {
                          setform({ ...form, seats: newValue });
                        }
                      }}
                      required
                    />
                  </div>
                </div>


              </div>






              <div className="grid grid-cols-12 gap-4">
                {/* {id ? null : ( */}
                <>

                  <div className="col-span-12 md:col-span-6 mb-3">
                    <div className='flex items-center mb-1'>
                      <input
                        // disabled={id}
                        checked={Checked12}
                        onChange={(e) => setChecked12(e.target.checked)}
                        type="checkbox" className='w-[15px] h-[15px]'
                      />
                      <input
                        type="text"
                        className="bg-white"
                        value={TwelveMonth?.label}
                        disabled
                        required={Checked12}
                      />


                    </div>

                    <input

                      type="number"
                      placeholder="Unit Amount"
                      className=" relative shadow-box bg-white rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2 w-full"
                      value={TwelveMonth?.unit_amount}
                      disabled={!Checked12||id}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        if (inputValue >= 0) {
                          setTwelveMonth({
                            ...TwelveMonth,
                            unit_amount: JSON.parse(inputValue),
                          });
                        }
                      }}
                      onKeyPress={(e) => {
                        const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
                        if (!allowedKeys.includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      required={Checked12}

                    />

                  </div>
                </>
                {/* )} */}
                <div className="col-span-12 md:col-span-12">
                  <div className="">
                    <h5 className="text-[#A12238]">
                      <b> Features </b>
                    </h5>
                  </div>
                  <div className="grid grid-cols-12 gap-4">
                    {features &&
                      features?.map((item, index) => {
                        return (
                          <>
                            <div
                              className={`${features?.length === 1 ? 'col-span-12' : 'col-span-6'
                                }`}>
                              <label class="form-check-label pointer">
                                <input
                                  class="form-check-input w-[15px] h-[15px] relative top-[2px]" id="red-checkbox"
                                  type="checkbox"
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedFeatures([
                                        ...SelectedFeature,
                                        { id: `${item.id}` },
                                      ]);
                                    } else {
                                      setSelectedFeatures(
                                        SelectedFeature.filter(
                                          (feature) => feature?.id != item.id
                                        )
                                      );
                                    }
                                  }}
                                  checked={isFeatureSelected(item?.id)}
                                />
                                {item?.name}
                              </label>
                            </div>
                          </>
                        );
                      })}
                  </div>
                </div>

              </div>
              <div className="flex justify-end">
                <button
                  type="submit"
                  className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:opacity-80 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
                >
                  Save
                </button>
              </div>
            </div>
          </form>}
      </Layout>
    </>
  );
};
export default AddEditPlan;
